import SVGInject from "@iconfu/svg-inject/dist/svg-inject";

export const svgInject = (function ($) {

    function init() {
        SVGInject($("img.js-svg-inject"));
    }

    return {
        init: init
    }

})(jQuery);